import { render, staticRenderFns } from "./logos.vue?vue&type=template&id=634fdf39"
import script from "./logos.vue?vue&type=script&lang=js"
export * from "./logos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports